export default __webpack_public_path__ + "static/office3-3x-192576477098acfdb1c1af0c0ad4a5e8.jpg";